import { View } from "ui/atoms/view";
import { Image, Text } from "react-native";
import { StatusFlagModel } from "app/services/api/types/statusFlags/models/StatusFlagModel";
import StatusFlagActionButtons from "../molecules/StatusFlagActionButtons";
import {
  Checkbox,
  CheckboxIcon,
  CheckboxIndicator,
} from "ui/gluestack/checkbox";
import { CheckIcon } from "ui/gluestack/icon";

export interface Props {
  flag: StatusFlagModel;
  onEdit?: (flag: StatusFlagModel) => void;
  onDelete?: (flag: StatusFlagModel) => void;
  onAssign?: (flagId: number, isChecked: boolean) => void;
  isSelected?: boolean;
}

export function ViewStatusFlagCard({
  flag,
  onEdit,
  onDelete,
  onAssign,
  isSelected = false,
}: Props) {
  return (
    <View className="bg-white rounded-lg p-5 min-h-[50px] flex flex-col justify-between sm:flex-row sm:items-start sm:justify-between overflow-hidden gap-4">
      <View className={`flex-row items-center flex-1 justify-between`}>
        <View className="flex-row gap-3 flex-1 max-w-[80%]">
          {onAssign ? (
            <Checkbox
              onChange={(isChecked: boolean) => {
                onAssign?.(flag.id, isChecked);
              }}
              size="sm"
              isChecked={isSelected}
              value={String(flag.id)}
            >
              <CheckboxIndicator>
                <CheckboxIcon as={CheckIcon} />
              </CheckboxIndicator>
            </Checkbox>
          ) : null}

          <Text className="text-base font-medium flex-shrink text-wrap">
            {flag.name}
          </Text>
        </View>
        <Image
          source={{ uri: flag.icon?.url }}
          className="w-16 h-16 object-contain"
          resizeMode="contain"
        />
      </View>
      {!onAssign ? (
        <View className="self-end sm:self-center ">
          <StatusFlagActionButtons
            flag={flag}
            onEdit={onEdit}
            onDelete={onDelete}
          />
        </View>
      ) : null}
    </View>
  );
}
